import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";


import "ace-builds/src-noconflict/theme-dawn";
import "ace-builds/src-noconflict/theme-nord_dark";

import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-beautify";

function Editor(props) {

  return (
    <AceEditor
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        overflow: "hidden",
        border:"solid grey 1px"
      }}
      placeholder="Start Coding"
      mode={props.type}
      theme={props.theme}
      name="basic-code-editor"
      onChange={props.handleCodeChange}
      fontSize={18}
      showPrintMargin={true}
      showGutter={true}
      highlightActiveLine={true}
      value={props.code}
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        showLineNumbers: true,
        tabSize: 4,
      }}
    />
  );
}

export default Editor;
